{
    "app": {
        "title": "Billing",
        "close_button": "Close",
        "loading": "Loading..."
    },
    "orders_dashboard": {
        "title": "Orders",
        "filter_all": "All",
        "filter_unassigned": "Unassigned",
        "filter_expiring": "Expiring",
        "filter_undeployed": "Available to Deploy",
        "filter_canActivate": "Available to Activate",
        "search_orders": "Search orders"
    },
    "orders_list": {
        "subscriptionExpiry": "SUBSCRIPTION EXPIRY",
        "end_of_orders_list": "end of orders list",
        "orderDate": "ORDER DATE",
        "orderNumber": "ORDER NUMBER",
        "subscriptionNumber": "SUBSCRIPTION NUMBER",
        "accountName": "ASSIGNED ACCOUNT", 
        "unassigned": "Unassigned",
        "unavailable": "Unavailable",
        "expiring": "EXPIRING SOON",
        "assign": "ASSIGN",
        "expired": "EXPIRED",
        "perpetual": "PERPETUAL",
        "pending": "PENDING ACTIVATION",
        "error_retrieving_orders": "There was an error retrieving the orders.",
        "no_orders_found": "No orders found.",
        "deploy": "Deploy",
        "activate": "Activate"
    },
    "order_details": {
        "deploy_button": "Deploy",
        "activate_button": "Activate",
        "assign_button": "Assign",
        "order_number": "Order #",
        "tracking_number": "Tracking Number",
        "subscription_number": "Subscription #",
        "see_additional_details": "See additional tracking details",
        "hide_additional_details": "Collapse additional tracking details",
        "invoiceOwnerAccountName": "Owner Account Name",
        "po_number": "Reseller PO Number",
        "reseller_SAP_Id": "Reseller SAP Id",
        "sapOrderId": "SAP Order Id",
        "order_assigned_to": "Order assigned to",
        "start_date": "Start date",
        "term": "Term",
        "please_pick_acct_msg": "We were not able to match this order so please manually select an account to apply it to.",
        "company": "Company",
        "create_new_account": "Create new account",
        "order_expiry_time": "ORDER WILL EXPIRE IN {{numdays}} DAY(S)",
        "licenses": "Licenses",
        "license": "License",
        "customerSapId": "Customer SAP ID",
        "customerPONumber": "Customer PO Number",
        "search_companies": "Search companies",
        "month": "Month",
        "year": "Year",
        "day": "Day",
        "unknown": "Unknown",
        "assigning_account_to_order": "Assigning Order to Account...",
        "deploying_order": "Deploying Order...",
        "activating_order": "Activating Order...",
        "error_assigning_order": "There was an error assigning the order to the account.",
        "error_deploying_order": "There was an error deploying the order.",
        "error_activating_order": "There was an error activating the order.",
        "cannot_comm_parent": "We can not redirect you to the proper form, You can create account from the Accounts app.",
        "no_results_found": "No results found",
        "existing-subscription": "Assignment failed: This company already has an order.",
        "0001": "Insufficient licenses. The number of assigned free licenses ({free}) exceeds the number of licenses ({paid}) in the paid order.",
        "restricted_view_warning": "Features disabled. Your access is restricted."
    },
    "order_complete": {
        "go-to-account-integrations": "Go to account integrations",
        "go-to-account": "Go to account",
        "activate-order": "Activate order",
        "order-added": "Order added!",
        "order-deployed": "Order deployed!",
        "order-activated": "Order activated!",
        "enable-integration": "Just a note, items in this order require an integration to be setup and enabled in order to work.",
        "activate-order-instructions": "Just a note, this order must be activated in order to work."
    },
    "errors": {
        "504-general-message": "The solution is busy or unreachable. Please try again.",
        "couldnt-find-order": "We couldn't find the order in the list. Please try reloading."
    }
}